import styled from "styled-components";

export const SpaceParent = styled.div`
  height:62.5px;    
  @media(min-width: 768px) {  
    height:125px;    
  }
`